import uuidv4 from 'uuid/v4'

export const randomUuid = () => {
    return uuidv4()
}

export const parseUrl = (url) => {
    if (url?.startsWith('/') !== -1) {
        return `${process.env.VUE_APP_API_URL}${url}`
    }
    return url
}

export const formatXml = (xml, tab) => {
    if (!xml) { return ""; }
    let formatted = '', indent= '';
    tab = tab || '\t';
    xml.replaceAll("&apos;", "'").split(/>\s*</).forEach(function(node) {
        if (node.match( /^\/\w/ )) indent = indent.substring(tab.length);
        formatted += indent + '<' + node + '>\r\n';
        if (node.match( /^<?\w[^>]*[^\\/]$/ )) indent += tab;
    });
    return formatted.substring(1, formatted.length-3);
}